import {
  AcceptedValuesResourceType,
  AttributeDefinition,
  AttributeValidationEnumConfig,
  PayeeEngagement,
  PayerEngagement
} from "@wingspanhq/wingspan-api-sdk";
import get from "lodash/get";

export function isDynamicEnumConfig(
  config: AttributeValidationEnumConfig
): boolean {
  return (
    "resourceType" in config &&
    "valuePath" in config &&
    "acceptedValues" in config
  );
}

export function isStaticEnumConfig(
  config: AttributeValidationEnumConfig
): boolean {
  return "acceptedValues" in config;
}

// The resource object powering dynamic enum lookups is the engagement as each
// seat sees it: the payee reads the counterpart `PayerEngagement`, the payer
// reads its own `PayeeEngagement`. `valuePath` therefore resolves against the
// v3 engagement shape on both sides.
export type AcceptedValuesResources = {
  payerPayeeEngagement?: PayerEngagement | PayeeEngagement;
};

export function getEnumValues(
  definition: AttributeDefinition,
  resources: AcceptedValuesResources
) {
  const config = definition.validationRules?.enumConfig;
  if (!config) {
    return [];
  }

  if (isDynamicEnumConfig(config)) {
    let resource: Record<string, any>;
    switch (config.resourceType) {
      case AcceptedValuesResourceType.PAYER_PAYEE_ENGAGEMENT:
        if (!resources.payerPayeeEngagement) {
          console.error(
            "PayerPayeeEngagement is required for dynamic enum values"
          );
          return [];
        }
        resource = resources.payerPayeeEngagement;
        break;
      default:
        return [];
    }

    const values = get(resource, config.valuePath ?? "");

    return Array.isArray(values) ? values : [values];
  }

  if (isStaticEnumConfig(config)) {
    return config.acceptedValues || [];
  }

  return [];
}
